var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Frame"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M15 12.5C15 12.5 11.3175 7.50001 9.99996 7.5C8.68238 7.49999 5 12.5 5 12.5",
  stroke: "black",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-chevron-down.2b1d8b4478e4bc065da02f17c4f4b2c8.svg";